import React from "react";
import styled from 'styled-components'
import { motion } from 'framer-motion'

const ContentLoadingSpinner = styled<any>(motion.div).attrs({
    initial: { opacity: 0 },
    animate: { scale: 0.9, opacity: [1, 0.25] },
    transition: { yoyo: Infinity, duration: 0.5, ease: "easeInOut", delay: 1 }
})`
    height:100px;
    width:100px;
    background-image: url('/static/squiggly.png');
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    background-size: 75%;
    border-radius: 50%;
`

export default ContentLoadingSpinner